import ArticleEditor from "assets/article-editor/article-editor.js";

ArticleEditor.add("plugin", "cqflag", {
    translations: {
        en: {
            cqflag: {
                "cq-flag": "CQ",
            },
        },
    },
    defaults: {
        icon: '<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" /></svg>',
        editorName: "arx-editor",
    },
    start: function () {
        this.app.toolbar.add("cqflag", {
            title: "## cqflag.cq-flag ##",
            icon: this.opts.cqflag.icon,
            position: { after: "specialchars" },
            blocks: {
                all: "editable",
                except: ["code"],
            },
            command: "cqflag.insert",
        });
    },
    insert: function () {
        // old insert method stopped working in 2.7.10 but I can't figure out why
        // think that's likely the last version of Article Editor for a bit...
        this._do_insert();
    },
    _do_insert: function () {
        this.app.insertion.insertHtml(
            '<span class="arx-snw-cqflag" title="' +
                this.opts.cqflag.editorName +
                " at " +
                new Date().toLocaleString() +
                '">' +
                this.app.selection.getText() +
                "</span> "
        );
    },
});
